import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Button, Placeholder, Table } from "react-bootstrap";
import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";
import PaypalAccountListItem from "./PaypalAccountListItem";

const PaypalAccountList = ({ accountList, setAccountList, updatingAccount, setUpdatingAccount }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const data = await Utils._apiRequest({
          path: Enums.endpoints.paypal.ACCOUNT,
          type: "GET",
        });
        setAccountList(Array.isArray(data) ? data : []);
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchAccounts();
  }, [setAccountList]);

  const mdRand = (min, max) => Math.round(Math.random() * (max - min) + min);

  return (
    <Table striped hover className="text-nowrap">
      <caption>Danh sách tài khoản PayPal</caption>
      <thead>
        <tr>
          <th width={20}>#</th>
          <th width={180}>Tên tài khoản</th>
          <th width={220}>Account</th>
          <th width={70}>Mode</th>
          <th width={80}>Trạng thái</th>
          <th>Email</th>
          <th width={120}></th>
        </tr>
      </thead>
      <tbody>
        {accountList.length > 0 ? (
          accountList.map((account, i) => (
            <PaypalAccountListItem
              key={account._id}
              account={account}
              index={i}
              accountList={accountList}
              setAccountList={setAccountList}
              updatingAccount={updatingAccount}
              setUpdatingAccount={setUpdatingAccount}
            />
          ))
        ) : loading ? (
          [1, 2, 3].map((i) => (
            <tr key={i} className="placeholder-group">
              <td>{i}</td>
              <td><Placeholder animation="glow"><Placeholder xs={mdRand(8, 12)} /></Placeholder></td>
              <td><Placeholder animation="glow"><Placeholder xs={mdRand(8, 12)} /></Placeholder></td>
              <td><Placeholder animation="glow"><Placeholder xs={6} /></Placeholder></td>
              <td><Placeholder animation="glow"><Placeholder xs={6} /></Placeholder></td>
              <td><Placeholder animation="glow"><Placeholder xs={mdRand(8, 12)} /></Placeholder></td>
              <td className="text-inline text-end">
                <Button className="ms-1" size="xs" disabled variant="secondary"><FontAwesomeIcon icon={faPen} /></Button>
                <Button className="ms-1" size="xs" disabled variant="danger"><FontAwesomeIcon icon={faTrashCan} /></Button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={7}>Chưa có tài khoản nào...</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default PaypalAccountList;
